import { FsCore } from '@t/fs-core'

export const getComponentsState = (s: FsCore.State) => s.components

export const getComponentById = (s: FsCore.State, id: string) => getComponentsState(s)[id]
